export const recs = {
  channel: "magazine_mobile",
};
